import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-63-uday-narang-guest.webp";
import ThumbImg from "../../assets/images/conversations/063.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: un-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .un-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .un-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .un-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .un-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .un-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .un-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un-hero__title.un-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .un-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .un-hero__spotify.un-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .un-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .un-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .un-hero__right.un-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .un-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .un-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .un-yt-thumb:hover img { opacity: 0.85; }
  .un-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .un-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .un-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .un-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .un-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un-body.un-visible { opacity: 1; transform: translateY(0); }
  .un-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .un-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .un-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .un-guest.un-visible { opacity: 1; transform: translateY(0); }
  .un-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .un-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .un-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .un-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .un-inner { padding-left: 32px; padding-right: 32px; }
    .un-hero { padding-top: 32px; padding-bottom: 48px; }
    .un-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .un-hero__title { font-size: 24px; }
    .un-hero__left { gap: 16px; }
    .un-guest__title { font-size: 24px; margin-bottom: 24px; text-align:left;}
    .un-guest__photo-bg { width: 260px; height: 300px; }
    .un-guest__name { font-size: 24px; margin-top: 18px; }
    .un-body__para { font-size: 14px; margin-bottom: 12px; }
    .un-body { padding-bottom: 48px; }
    .un-guest { padding-bottom: 48px; }
    .un-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .un-inner { padding-left: 16px; padding-right: 16px; }
    .un-hero { padding-top: 51px; padding-bottom: 30px; }
    .un-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .un-hero__left { gap: 30px; }
    .un-hero__title { font-size: 30px; }
    .un-body__para { font-size: 16px; margin-bottom: 10px; }
    .un-guest__title { font-size: 30px; margin-bottom: 20px; }
    .un-guest__photo-bg { width: 100%; height: 386px; }
    .un-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .un-body { padding-bottom: 30px; }
    .un-guest { padding-bottom: 30px; }
    .un-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("un-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="un-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 63 Uday Narang"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="un-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 63 Uday Narang thumbnail" />
      <div className="un-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="un-hero">
      <div className="un-inner">
        <div className="un-hero__grid">
          <div className="un-hero__left">
            <h1 ref={titleRef} className="un-hero__title">
              EP 63 | Remaining India's Mobility Future | A Visionary Talk with Uday NARANG
            </h1>
            <div ref={spotifyRef} className="un-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6lD8cASDSGa7AihOmsCiOS?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 63 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="un-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="un-body">
      <div className="un-inner">
        <p className="un-body__para">
          Today, we welcome back Uday Narang San. Uday is one of the few real innovators of electronic mobility in India. Focusing on the 2-wheeler, 3-wheeler, and 4-wheeler transport space in India. And it's always exciting to have Uday on the show to have a candid conversation about what gives and often what does not. Uday San, welcome to the program.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="un-guest">
      <div className="un-inner">
        <h2 className="un-guest__title">Our Guest</h2>
        <div>
          <div className="un-guest__photo-bg">
            <img src={GuestImg} alt="Uday Narang" />
          </div>
          <p className="un-guest__name">Uday NARANG</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep63UdayNarang() {
  return (
    <>
      <style>{CSS}</style>
      <div className="un-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}